import PaymentDueSummary from "./PaymentDueSummary";
import { connect } from "react-redux";
import { getTotalExcludedTaxes } from "app/pages/Booking/bookingSelectors";

const mapStateToProps = (state, { total }) => {
	const payAtPropertyAmount = getTotalExcludedTaxes(state);

	return {
		payNowAmount: total,
		payAtPropertyAmount,
	};
};

export default connect(mapStateToProps)(PaymentDueSummary);
